import { atom } from "jotai";

import { AppInterface } from "@ts/interfaces/Checkout/AppInterface";

export const appAtom = atom<AppInterface>({
    location: "au",
    currency: "aud", // only support AUD for now
    language: "en"
});

// Defining debug info for the atoms created to be consumed by the Jotai DevTools
appAtom.debugLabel = "appAtom";
